import CoinWidget from 'src/pages/CoinWidget'

export default CoinWidget

export const getServerSideProps = ({ query }) => {
  return {
    props: { slug: query.coin },
  }
}
